import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ISummaryState {
  monthlyTotal: string
  prorateTotal: string
}

const initialState: ISummaryState = {
  monthlyTotal: '',
  prorateTotal: '',
}

export const slice = createSlice({
  name: 'summary',
  initialState,
  reducers: {
    onMonthlyTotal: (
      state: ISummaryState,
      action: PayloadAction<typeof initialState.monthlyTotal>
    ) => {
      state.monthlyTotal = action.payload
    },
    onProrateTotal: (
      state: ISummaryState,
      action: PayloadAction<typeof initialState.prorateTotal>
    ) => {
      state.prorateTotal = action.payload
    },
  },
})

export const { actions, reducer } = slice

export type ISummary = {
  summary: ISummaryState
}
